// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aliasPage {
    margin-top: 1rem;
}
.ml-auto {
    margin-left: auto;
}
.tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

.tooltip-container i {
  cursor: help;
  position: relative;
}

.tooltip-container i:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  background: #333;
  color: white;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 1000;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
}
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.mr-2 {
  margin-right: 0.5rem;
}

.break-all {
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./fablesite/js/Pages/GlobalViewPage/GlobalViewPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uGAAuG;EACvG,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".aliasPage {\n    margin-top: 1rem;\n}\n.ml-auto {\n    margin-left: auto;\n}\n.tooltip-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  margin-left: 4px;\n}\n\n.tooltip-container i {\n  cursor: help;\n  position: relative;\n}\n\n.tooltip-container i:hover::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 5px 10px;\n  background: #333;\n  color: white;\n  border-radius: 4px;\n  font-size: 14px;\n  white-space: nowrap;\n  z-index: 1000;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n}\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.mr-2 {\n  margin-right: 0.5rem;\n}\n\n.break-all {\n  word-break: break-all;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
